export default __webpack_public_path__ + "static/media/cookie5.262209f8.svg";